import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getAllAssignmentApi,
  uploadAssignmentApi,
  deleteAssignmentApi,
  updateAssignmentApi
} from "../../apis/assignment";

export const getAllAssignment = createAsyncThunk(
  "assignment/getAll",
  async () => {
    const response = await getAllAssignmentApi();
    return response.data.data;
  }
);


export const uploadAssignment = createAsyncThunk(
  "assignment/upload",
  async (formData) => {
    const response = await uploadAssignmentApi(formData);
    return response.data.assignment;
  }
);


export const updateAssignment = createAsyncThunk(
  "assignment/update",
  async ({ id, formData }, { rejectWithValue }) => {
    try {
      const response = await updateAssignmentApi(id, formData);
      return response.data.assignment; // Ensure it returns updated data
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to update assignment");
    }
  }
);

export const deleteAssignment = createAsyncThunk(
  "assignment/delete",
  async (id, { rejectWithValue }) => {
    try {
      await deleteAssignmentApi(id);
      return id;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to delete subject"
      );
    }
  }
);

const assignmentSlice = createSlice({
  name: "assignments",
  initialState: {
    assignments: [],
    status: "idle",
    error: null,
  },
  reducers: {
    reset: (state) => {
      state.assignments = [];
      state.status = "idle";
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllAssignment.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getAllAssignment.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.assignments = action.payload;
      })
      .addCase(getAllAssignment.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });

    // upload assignment
    builder
      .addCase(uploadAssignment.pending, (state) => {
        state.status = "loading";
      })
      .addCase(uploadAssignment.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.assignments.push(action.payload); // Add new assignment
      })
      .addCase(uploadAssignment.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      // delete assignment
      .addCase(deleteAssignment.pending, (state) => {
        state.status = "loading";
      })
      .addCase(deleteAssignment.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.assignments = state.assignments.filter(
          (removeAssignment) => removeAssignment.id !== action.payload
        );
      })
      .addCase(deleteAssignment.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "Failed to delete course.";
      })

      // update assignment
      .addCase(updateAssignment.pending, (state) => {
        state.status = "loading";
      })
      .addCase(updateAssignment.fulfilled, (state, action) => {
        state.status = "succeeded";
        const index = state.assignments.findIndex(
          (assignment) => assignment.id === action.payload.id
        );
        if (index !== -1) {
          state.assignments[index] = action.payload; // Update the assignment
        }
      })
      .addCase(updateAssignment.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "Failed to update assignment.";
      });

  },
});
export default assignmentSlice.reducer;
